import { Subscribe } from "@react-rxjs/core"
import { ComponentProps } from "react"

import { LayoutProps } from "../types"
import { RegionLayout } from "./RegionLayout"

export const Region = ({
  source$,
  fallback,
  children,
  ...props
}: LayoutProps & ComponentProps<typeof Subscribe>) => (
  <Subscribe source$={source$} fallback={fallback}>
    {children}
    <RegionLayout {...props} />
  </Subscribe>
)
